import React from 'react';
import { selectedAttributes } from '../Infrastructure/attributes';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../util/translationUtility';
import { PRODUCTS } from "../constants";

const ProductSearchResultsNonFound = ({ attributes, onClearAttributes, resultType, isCategoryPage, customerServiceTextAndLink }) => {
    const hasAttributes = attributes && selectedAttributes(attributes).length > 0;
    return (
        <div className="no-products">
            <span className="no-products__text d-block">
                {(isCategoryPage && !hasAttributes)
                    ? translateResourceString("/Search/NoProductsInMarket")
                    : (resultType === PRODUCTS)
                        ? translateResourceString("/Search/NoResultsFound")
                        : translateResourceString("/Search/NoResultsFoundArticles")
                }
            </span>

            {isCategoryPage && !hasAttributes &&
                <span className="no-products__contact d-block mt-3" dangerouslySetInnerHTML={{ __html: customerServiceTextAndLink }} />
            }

            {hasAttributes &&
                <span className="no-products__button">
                    <span>{translateResourceString("/Search/Try")}</span>
                    <button className="btn btn-clear" onClick={() => onClearAttributes()}>{translateResourceString("/Search/ClearingFilters")}</button>
                </span>
            }
        </div>
    )
}

ProductSearchResultsNonFound.propType = {};

export default ProductSearchResultsNonFound;